<template>
  <div>
    <el-dialog
      :visible="visible"
      :show-close="false"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="650px"
      top="0">
      <div slot="title" class="dialog-title dialog-top">
        <div class="dialog-detail">
          <span class="detail">{{ $t('回复') }}</span>
        </div>
        <img class="dialog-close" src="@/assets/images/close.png" alt="" @click="onClose"/>
      </div>
      <div class="form-content">
        <el-form ref="form" :model="form" :rules="rules" label-width="110px">
          <el-form-item prop="replytype" :label="$t('回复类型')">
            <el-select clearable v-model="form.replytype" :placeholder="$t('请选择')">
              <el-option v-for="item in replyTypeList" :key="item.value" :label="item.label" :value="item.value" :placeholder="$t('请选择')"/>
            </el-select>
          </el-form-item>
          <el-form-item prop="deliveryDate" :label="$t('预约派送日期')" v-if="form.replytype === 2">
            <el-date-picker v-model="form.deliveryDate"
                            type="date"
                            :placeholder="$t('请选择')"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            :picker-options="pickerOptions"/>
          </el-form-item>
          <el-form-item prop="deliveryTimeRange" :label="$t('预约派送时间')" v-if="form.replytype === 2">
            <el-select clearable v-model="form.deliveryTimeRange" :placeholder="$t('请选择')">
              <el-option v-for="item in timeLimitOpt" :key="item.value" :label="item.name" :value="item.value" :placeholder="$t('请选择')"/>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('备注')" v-if="isShowRemark">
            <el-input type="textarea"
                      v-model="form.remark"
                      maxlength="200"
                      :placeholder="$t('请输入')"
                      :autosize="{ minRows: 8, maxRows: 8}"
                      show-word-limit
                      style="width: 450px;"/>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="footer">
        <el-button type="primary" class="close" @click="onClose">{{ $t('取消') }}</el-button>
        <el-button type="primary" :loading="isLoading" @click="submitReply">{{ $t('提交回复') }}</el-button>
      </div>
    </el-dialog>
    <!--问题件退回申请-->
    <ProblemReturnApplyDialog ref="ProblemReturnApplyRef" @success="handleProblemReturnApplySuccess"/>
  </div>
</template>

<script>
import { fetchProblemBatchApplyCheckByReturn, fetchProblemReply, fetchProblemReplyByDelivery, batchCheckApply, getAbnormalPiece } from '@/api/module/problemPiece.js'
import { RESPONSE_SUCCESS } from '@/constants/index.js'
import { DICT } from '@/utils/dict.js'
import { RULES } from '@/utils/rules.js'
import { mapGetters } from 'vuex'
import ProblemReturnApplyDialog from './ProblemReturnApplyDialog.vue'

export default {
  name: 'TheReplyDialog',
  components: {
    ProblemReturnApplyDialog,
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  provide() {
    return {
      replytype: () => this.form.replytype
    }
  },
  inject: ['selectedRows'],
  data() {
    const that = this
    return {
      replyTypeList: DICT.clientInstructList,
      timeLimitOpt: [
        { name: '09:00-12:00', value: 1 },
        { name: '12:00-15:00', value: 2 },
        { name: '15:00-18:00', value: 3 },
        { name: '09:00-18:00', value: 4 }
      ],
      form: {
        replytype: '', // 回复类型
        deliveryDate: '', // 预约派送时间
        remark: '', // 备注
        deliveryTimeRange: '' // 派送时间
      },
      rules: {
        replytype: [RULES.requiredSelect],
        deliveryDate: [RULES.requiredSelect],
        deliveryTimeRange: [RULES.requiredSelect],
      },
      pickerOptions: {
        disabledDate(time) { // 派送时间不可选当天，如果15点前，自第二天开始10天以内可选，15点后，自第三天开始10天以内可选
          const disabledDateNum = that.isSa ? 10 : that.disabledDateNum
          const maxTime = disabledDateNum * 24 * 60 * 60 * 1000
          const oneDayTime = 24 * 60 * 60 * 1000
          const threeTime = new Date(new Date().toDateString() + ' 15:00')
          const nowDate = new Date().valueOf()
          let nowTime = Date.now()
          let lastDate = maxTime + nowDate
          // 过了15点，自第三天开始10天以内可选
          if (nowTime > threeTime.getTime()) {
            nowTime = Date.now() + oneDayTime
            lastDate = maxTime + nowDate + oneDayTime
          }
          return time.getTime() < nowTime || time.getTime() > lastDate
        }
      },
      selectedData: [],
      isLoading: false, // 加载
      successNum: 0,
      errorNum: 0,
      failList: [],
      disabledDateNum: 10, // 可预约时间
    }
  },
  computed: {
    ...mapGetters(['user']),
    isShowRemark() {
      // 1-退回, 2-预约派送,3-待确认
      const replytype = this.form.replytype
      if (replytype === 1) {
        return false
      } else if (replytype === 2) {
        return true
      } else if (replytype === 3) {
        return true
      }
      return false
    },
    isSa() {
      return this.user.countryId === 1
    },
  },
  watch: {
    'form.replytype'(val) {
      this.form.deliveryDate = '' // 预约派送时间
      this.form.remark = '' // 备注
      this.form.deliveryTimeRange = '' // 派送时间
    },
    visible(val) {
      this.selectedData = this.selectedRows()
      val && this.getAbnormalPiece()
    }
  },
  methods: {
    // 获取可预约时间
    async getAbnormalPiece() {
      try {
        const { code, data, msg } = await getAbnormalPiece()
        if (code === RESPONSE_SUCCESS) {
          const { appointmentDays } = data
          this.disabledDateNum = appointmentDays && appointmentDays >= 1 ? appointmentDays : 0
        } else {
          this.disabledDateNum = 0
          this.$message.error(msg)
        }
      } catch (err) {
        this.disabledDateNum = 0
        console.log('🚀 ~ replytypeChange ~ err:', err)
      }
    },
    showDialog() {
      this.$emit('update:visible', true)
    },
    onClose() {
      this.form.replytype = ''
      this.resetForm()
      this.$emit('update:visible', false)
    },
    /**
     * 重置表单
     */
    resetForm() {
      this.form.deliveryDate = '' // 预约派送时间
      this.form.remark = '' // 备注
      this.form.deliveryTimeRange = '' // 派送时间
      this.$refs['form'].resetFields()
    },
    /**
     * 处理问题件申请成功回调
     */
    handleProblemReturnApplySuccess() {
      this.onClose()
      this.$emit('success')
    },
    /**
     * 提交申请
     * 1-退回, 2-预约派送,3-待确认
     */
    submitReply() {
      if (this.selectedData.length === 0) return this.$message.error(this.$t('数据异常'))

      this.$refs['form'].validate(async valid => {
        if (valid) {
          const { replytype } = this.form
          // 退回
          if (replytype === 1) {
            await this.handleReturn()
          }
          // 预约派送
          if (replytype === 2) {
            if (this.selectedData.length > 100) return this.$message.error(this.$t('单次申请预约派送仅支持100条以内'))
            await this.handleDelivery()
          }
          // 待确认
          if (replytype === 3) {
            await this.handleToBeConfirmed()
          }
        } else {
          return false
        }
      })
    },
    /**
     * 处理退回
     */
    async handleReturn() {
      const waybillNos = this.selectedData.map(item => item.waybillNo).toString()

      this.isLoading = true
      // 退回件是否可以批量申请
      const { code, data, msg } = await fetchProblemBatchApplyCheckByReturn({
        waybillNos: waybillNos,
      })
      this.isLoading = false

      if (code === RESPONSE_SUCCESS) {
        if (data && data.length) {
          this.$refs['ProblemReturnApplyRef'].showDialog()
        } else {
          this.$message.error(this.$t('所选运单暂不支持退回申请'))
        }
      } else {
        this.$message.error(this.$t(msg))
      }
    },
    /**
     * 处理预约派送
     */
    async handleDelivery() {
      try {
        this.errorNum = 0
        this.isLoading = true
        await this.getReturnErrorWaybill()
        await this.beforeHandleDelivery()
        this.$message.success(`${this.$t('成功')}${this.successNum}${this.$t('条')}, ${this.$t('失败')}${this.errorNum}${this.$t('条')}`)
        // this.$emit('success')
        this.$emit('success', this.failList)
        this.isLoading = false
        this.resetForm()
        this.failList = []
        this.$emit('update:visible', false)
      } catch (err) {
        this.isLoading = false
      }
    },
    // 轮询调用预约派送接口
    async beforeHandleDelivery() {
      this.successNum = 0
      // this.errorNum = 0
      const { deliveryTimeRange, deliveryDate, replytype, remark } = this.form
      for (let i = 0; i < this.selectedData.length; i++) {
        const params = {
          waybillNo: this.selectedData[i].waybillNo,
          deliveryTimeRange: deliveryTimeRange,
          deliveryDate: deliveryDate,
          countryId: this.user.countryCode === 'KSA' ? 1 : 2,
          clientInstruct: replytype,
          ids: [this.selectedData[i].id],
        }
        const params2 = {
          ids: [this.selectedData[i].id],
          deliveryTimeRange: deliveryTimeRange,
          deliveryDate: deliveryDate,
          clientInstruct: replytype,
          clientRemark: remark,
          waybillNos: [this.selectedData[i].waybillNo]
        }
        const res = await fetchProblemReplyByDelivery(params)
        const res2 = res.code === 1 && await fetchProblemReply(params2)
        if (res && res.code === RESPONSE_SUCCESS && res2 && res2.code === RESPONSE_SUCCESS) {
          this.successNum += 1
        } else {
          this.errorNum += 1
        }
      }
    },
    // 获取退件运单号
    async getReturnErrorWaybill() {
      const waybillNos = this.selectedData.map(item => item.waybillNo)
      const params = {
        waybillNos
      }
      const { code, data } = await batchCheckApply(params)
      if (code === RESPONSE_SUCCESS) {
        if (data.failList && data.failList.length > 0) {
          this.failList = data.failList
          // 移除选中数据中退件的运单号
          this.failList.forEach((item) => {
            this.selectedData.forEach((v, k) => {
              if (item === v.waybillNo) {
                this.selectedData.splice(k, 1)
              }
            })
          })
          this.errorNum = data.failList && data.failList.length || 0
          this.$message.error(data.errorMsg)
        }
      }
    },
    /**
     * 待确认
     */
    async handleToBeConfirmed() {
      const { remark, replytype } = this.form
      const ids = this.selectedData.map(item => item.id)

      this.isLoading = true
      // 回复接口
      const { code, msg } = await fetchProblemReply({
        ids: ids,
        clientInstruct: replytype,
        clientRemark: remark
      })
      this.isLoading = false
      if (code === RESPONSE_SUCCESS) {
        this.resetForm()
        this.$emit('update:visible', false)
        this.$emit('success')
      } else {
        this.$message.error(this.$t(msg))
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.dialog-top {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .dialog-detail {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .detail {
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFangSC;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      line-height: 16px;
    }
  }

  .dialog-close {
    width: 16px;
    height: 16px;
    display: inline-block;
    cursor: pointer;
  }
}

::v-deep {
  .el-dialog__footer {
    border-top: 1px solid #eee;
  }
}

.footer {
  text-align: center;

  .close {
    background: #ffffff;
    border: 1px solid #cccccc;
    color: black;
  }
}
</style>
